import React from 'react';
import { ContractType } from 'features/contracts/enums/contractType';

interface Props {
  contractType: ContractType;
}

const EnergyUnit = ({ contractType }: Props) => {
  if (contractType === "ElectricityLowVoltage") {
    return <span> kWh</span>; 
  } else if (contractType === "GasSmallConsumption") {
    return <span> m<sup>3</sup></span>; 
  } 
  
  return <></>;
}

export default EnergyUnit;
